<div class="event-filter-wrapper">
    <span class="event-filter-icon-wrapper" *ngIf="isSpecialOffer">
        <i class="event-filter-icon di di-special-offers" aria-hidden="true"></i>
    </span>
    <span class="event-filter-label" translate>{{ labelTranslationKey }}</span>
    <span class="event-filter-name" translate>{{ nameTranslationKey }}</span>
</div>
